module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "invoices"
  }, [_c('div', {
    staticClass: "panel"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e0ee910!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices.vue
// module id = 2074
// module chunks = 2